(function () {
  var MAX_SIZE = 24;
  var MIN_SIZE = 14;

  function fitTitle(el) {
    var size = MAX_SIZE;
    el.style.fontSize = size + 'px';
    while (el.scrollWidth > el.clientWidth && size > MIN_SIZE) {
      size -= 1;
      el.style.fontSize = size + 'px';
    }
  }

  function fitAllTitles() {
    if (window.matchMedia('(max-width: 767px)').matches) {
      document
        .querySelectorAll('.product-title-row .product-title')
        .forEach(fitTitle);
    }
  }

  document.addEventListener('DOMContentLoaded', fitAllTitles);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fitAllTitles, 200);
  });
})();